import {useEffect} from "react";

// Lightweight, dependency-free SEO/head manager. Sets <title>, meta description,
// Open Graph + Twitter cards, and an optional JSON-LD block — imperatively, so
// we don't need react-helmet on this React 16 app. Meta tags are upserted (the
// next route overwrites them); the JSON-LD block is removed on unmount so stale
// structured data never lingers.
const upsertMeta = (attr, key, content) => {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (content == null || content === "") {
    if (el) el.removeAttribute("content");
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function Seo({title, description, image, url, type = "website", jsonLd}) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";
  const href = url || (typeof window !== "undefined" ? window.location.href : "");

  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:url", href);

    upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    if (jsonLdStr) {
      let s = document.getElementById("rd-jsonld");
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "rd-jsonld";
        document.head.appendChild(s);
      }
      s.textContent = jsonLdStr;
    }
    return () => {
      const s = document.getElementById("rd-jsonld");
      if (s) s.remove();
    };
  }, [title, description, image, href, type, jsonLdStr]);

  return null;
}
